<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';
import { useAdmin } from 'dashboard/composables/useAdmin';
import { useAccount } from 'dashboard/composables/useAccount';
import { useMapGetter } from 'dashboard/composables/store';
import Banner from 'dashboard/components/ui/Banner.vue';

const { t } = useI18n();
const router = useRouter();
const { isAdmin } = useAdmin();
const { accountId, currentAccount } = useAccount();
const isOnChatwootCloud = useMapGetter('globalConfig/isOnChatwootCloud');

const access = computed(() => currentAccount.value?.access);
const paidAccessReasons = [
  'payment_grace',
  'payment_grace_expired',
  'subscription_ended',
];
const isReadOnly = computed(() => access.value?.mode === 'read_only');
const shouldShow = computed(
  () =>
    isOnChatwootCloud.value &&
    paidAccessReasons.includes(access.value?.reason) &&
    (isAdmin.value || isReadOnly.value)
);
const bannerMessage = computed(() => {
  if (access.value?.reason === 'payment_grace') {
    return t('BILLING_SETTINGS.STATUS.PAST_DUE_NOTE');
  }
  if (access.value?.reason === 'payment_grace_expired') {
    return t('BILLING_SETTINGS.ACCESS.REASON.PAYMENT_GRACE_EXPIRED');
  }
  return t('BILLING_SETTINGS.ACCESS.REASON.SUBSCRIPTION_ENDED');
});
const actionButtonLabel = computed(() => {
  if (isReadOnly.value) {
    return t('BILLING_SETTINGS.ACTION.REACTIVATE');
  }
  return t('BILLING_SETTINGS.STATUS.PAST_DUE_ACTION');
});

const routeToBilling = () => {
  router.push({
    name: 'billing_settings_index',
    params: { accountId: accountId.value },
  });
};
</script>

<template>
  <div class="contents">
    <Banner
      v-if="shouldShow"
      :color-scheme="isReadOnly ? 'alert' : 'warning'"
      :banner-message="bannerMessage"
      :action-button-label="actionButtonLabel"
      :has-action-button="isAdmin"
      @primary-action="routeToBilling"
    />
  </div>
</template>
